import { render } from "./Tree.vue?vue&type=template&id=aa87859c&scoped=true&ts=true"
import script from "./Tree.vue?vue&type=script&lang=tsx"
export * from "./Tree.vue?vue&type=script&lang=tsx"

import "./Tree.vue?vue&type=style&index=0&id=aa87859c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa87859c"]])

export default __exports__